import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import EditDeleteButton from "components/table/EditDeleteButton";
import React from "react";
import useToggleDrawer from "hooks/useToggleDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import TopSellingDrawer from "components/drawer/TopSellingDrawer";

const TopSellingTable = ({
  fixedItineraryPeriodicHike,
  perpage,
  currentPage,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();
  const fixedItineraryPeriodicHikesorted = fixedItineraryPeriodicHike.sort(
    (a, b) => a.statename.localeCompare(b.statename)
  );
  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <TopSellingDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {fixedItineraryPeriodicHikesorted
          ?.slice(0, perpage)
          .map((data, index) => (
            <TableRow key={data.id}>
              <TableCell className="text-sm text-center">
                {(currentPage - 1) * perpage + index + 1}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data["statename"]}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data["package_code"]}
              </TableCell>

              <TableCell className="text-sm text-center">
                {data["route"]}
              </TableCell>


              <TableCell className="text-sm text-center">
                {data["no_of_days"]}/{data["no_of_nights"]}
              </TableCell>

              <TableCell className="text-center">
                <EditDeleteButton
                  title={data["Slider"]}
                  id={data.id}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideDelete={hideDelete}
                  hideEdit={hideEdit}
                />
              </TableCell>
            </TableRow>
          ))}
      </TableBody>
    </>
  );
};

export default TopSellingTable;
